import React from 'react';
import { proofStats, shortQuotes } from '../data/content';
export function ProofStrip() {
  return <section aria-label="Resultados y opiniones rápidas" className="border-b border-line bg-sand" data-id="element-194" data-mp="3g9gto1w02ypi">
      <div className="mx-auto max-w-6xl px-5 py-12" data-id="element-195" data-mp="3bacmthwjtd2c">
        <dl className="grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-196" data-mp="3b8t65q6zd001">
          {proofStats.map(stat => <div key={stat.label} className="border-l-2 border-accent/40 pl-4" data-id="element-197" data-mp="369q0c3j6epr0">
              <dt className="sr-only" data-id="element-198" data-mp="7tnfvut201c5">{stat.label}</dt>
              <dd data-id="element-199" data-mp="2ukk70yyr7gu">
                <span className="block font-display text-3xl font-semibold leading-none text-ink" data-id="element-200" data-mp="2w402qgpjgi3">
                  {stat.value}
                </span>
                <span className="mt-2 block text-[13px] leading-snug text-ink-soft" data-id="element-201" data-mp="3u386pk8xx0pz">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-12 grid gap-8 border-t border-line pt-10 lg:grid-cols-3" data-id="element-202" data-mp="2ik41xiamoek2">
          {shortQuotes.map(item => <figure key={item.author} className="flex h-full flex-col" data-id="element-203" data-mp="2emzknjrjyo0e">
              <blockquote className="font-display text-[17px] italic leading-snug text-ink" data-id="element-204" data-mp="3bbjbe361iu82">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-4 text-[11px] font-semibold uppercase tracking-eyebrow text-ink-mute" data-id="element-205" data-mp="32al51e84qamb">
                {item.author}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}